import {Injectable} from '@angular/core';
import {Actions, ofActionSuccessful, Store} from '@ngxs/store';

import {DeleteEntity} from 'app/blocks/store/actions/entity-actions';
import {GetEntityList} from 'app/blocks/store/actions/entity-actions';

@Injectable({
    providedIn: 'root'
})
export class EntityActionHandler {
    constructor(
        private _store: Store,
        private _actions: Actions
    ) {}

    init(): void {
        this._actions.pipe(ofActionSuccessful(DeleteEntity)).subscribe((action: DeleteEntity) => {
            console.log(`[EntityActionHandler] Firing reload of ${action.resource.name} list due to a delete`);
            this._store.dispatch(new GetEntityList(action.resource));
        });

        // this._actions.pipe(ofActionCompleted(GetEntityList)).subscribe(({ action }) => {
        //     console.log(`[EntityActionHandler] Setting statuses to false for ${action.resource.name}`);
        //     this._store.dispatch(action.resource.action.forGetEntityList());
        // });

        // this._actions.pipe(ofActionDispatched(...actionTypes)).subscribe((action: IEntityAction) => {
        //     console.log(`                               ============= Action fired with payload: ==============`);
        //     console.log(action);
        // });

        // this._store.select(state => state).subscribe(state => {
        //     console.log('                                 <<<<<<<<<<<<<<<< APP STATE >>>>>>>>>>>>>>');
        //     console.log(state);
        // });
    }
}
